import { useEffect } from 'react';
import { FormState } from 'react-hook-form';

type FormDataWithAnswers = {
  answers?: unknown[];
};

export const useScrollToFirstError = <T extends FormDataWithAnswers>(
  formState: FormState<T>,
) => {
  useEffect(() => {
    if (formState.submitCount > 0 && formState.errors.answers) {
      const answersErrors = formState.errors.answers as unknown[];
      const firstErrorIndex = answersErrors.findIndex(
        (error) => error !== undefined,
      );

      if (firstErrorIndex !== -1) {
        const errorElement = document.getElementById(
          `question-${firstErrorIndex}`,
        );
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  }, [formState.submitCount, formState.errors]);
};
